import { defineComponent as _defineComponent } from 'vue'
import {onMounted, onUnmounted, ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BoosterCounter',
  props: {
  startDate: {
    type: Date,
    required: true
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const days = ref(0);
const hours = ref(0);
const minutes = ref(0);
const seconds = ref(0);

const interval = ref();

const calculateTimeRemaining = () => {
  const now = new Date();
  const difference = props.startDate?.getTime() - now.getTime();

  if (difference > 0) {
    days.value = Math.floor(difference / (1000 * 60 * 60 * 24));
    hours.value = Math.floor((difference / (1000 * 60 * 60)) % 24);
    minutes.value = Math.floor((difference / 1000 / 60) % 60);
    seconds.value = Math.floor((difference / 1000) % 60);
  } else {
    days.value = 0;
    hours.value = 0;
    minutes.value = 0;
    seconds.value = 0;
    clearInterval(interval.value);
  }
};

onMounted(() => {
  calculateTimeRemaining();
  interval.value = setInterval(calculateTimeRemaining, 1000);
});

onUnmounted(() => {
  clearInterval(interval.value);
});

const __returned__ = { props, days, hours, minutes, seconds, interval, calculateTimeRemaining }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})